import {PropertyBase} from "./PropertyBase";


export class IconStyleProperty extends PropertyBase{

    protected InternalGetElement(): JQuery {
        let ispr=(window as any).rednaoPDFInvoiceParams.IsPr;
        let $container= jQuery(
            `<div>
                <div style="width: 40px;float:left;text-align: center;">
                    <div style="height: 40px;padding-top: 3px;">
                        <span style="font-size: 26px !important;vertical-align: top;font-family: ${this.Options.IconData.font}">${this.Options.IconData.value}</span>
                    </div>
                    <input   name="iconStyle" type="radio" value="basic"/>
                </div>
                <div style="float:left;text-align: center;margin-left: 15px;">    
                    <div style="position: relative;width: 40px;">
                        <img style="width:40px;height:40px" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwcHgiIGhlaWdodD0iMTAwcHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGZpbGw9ImJsYWNrIj48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSI1MCIgIC8+PC9zdmc+">
                        <div style="position: absolute;top:3px;left: 0;width:100%;text-align: center;">                         
                            <span style="font-size: 26px !important;color:white;width:30px;height:30px;vertical-align: top;font-family: ${this.Options.IconData.font}">${this.Options.IconData.value}</span>
                        </div>
                    </div>
                    <input ${ispr?'':'disabled="disabled"'} name="iconStyle" type="radio" value="round"/>
                </div>
                <div style="float: left;text-align: center;margin-left: 15px;">
                    <div style="position: relative;width: 40px;">
                        <img style="width: 40px;height:40px;" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBoZWlnaHQ9IjEwMHB4IiBzdHJva2U9IiMwMDAwMDAiIGZpbGw9IiMwMDAwMDAiIHdpZHRoPSIxMDBweCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSI+PC9yZWN0Pjwvc3ZnPg==">
                         <div style="position: absolute;top:3px;left: 0;width:100%;text-align: center;">                         
                            <span style="font-size: 26px !important;color:white;width:30px;height:30px;vertical-align: top;font-family: ${this.Options.IconData.font}">${this.Options.IconData.value}</span>
                        </div>
                    </div>
                    <input ${ispr?'':'disabled="disabled"'} name="iconStyle" type="radio" value="square"/>
                </div>
            </div>`
        );
        let value=this.GetOptionValue();
        if(value=='')
            value='basic';

        let self=this;
        $container.find('input').removeAttr('checked').change(function(e){
            if(!ispr)
            {
                e.preventDefault();
                e.stopImmediatePropagation();
                alert('Sorry you can only use this option in the full version');
                $container.find('input').removeAttr('checked');
                $container.find('input[value="basic"]').attr('checked','checked');

            }else{
                self.SetOptionValue($container.find('input:checked').val());
            }

        });
        $container.find('input[value="'+value+'"]').attr('checked','checked');
        return $container;
    }

    protected InternalGenerationCompleted($element: JQuery) {
    }

    public SubRenderer(): React.ReactNode {
        return undefined;
    }

}

declare let rednaoPDFInvoiceParams:any;